document.addEventListener('DOMContentLoaded', function () {
  const signups = document.querySelectorAll('.newsletter-signup-trigger');
  signups.forEach((signup) => {
    signup.addEventListener('click', function (e) {
      window._klOnsite.push(['openForm', 'VeReHU']);
    });
  });
});